<template>
  <div class="page h-100 p-relative" ref="page">
    <div class="container">
      <div class="flex align-center mb-30">
        <img src="/images/weizhi.png" alt="" class="mr-10">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/overallScheme.html' }">我的方案</el-breadcrumb-item>
          <el-breadcrumb-item>{{customerprogrammeInfo.name}} - 详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="font-40 color-292a2e font-yahei mb-4 flex align-center justify-center">
        {{customerprogrammeInfo.name}}
        <img src="/images/bianji.png" alt="" class="ml-20 cursor" @click="onEdit">
      </div>
      <div class="flex justify-center align-center color-292a2e font-16 font-yahei mb-28">
        <div class="flex align-center" v-if="customerprogrammeInfo.customerSpaceList && customerprogrammeInfo.customerSpaceList.length>0">
          <span v-for="(item, index) in customerprogrammeInfo.customerSpaceList" :key="index" class=" lh-24"><i class="el-icon-plus font-14 mlr-5" v-if="index !== 0"></i>{{item.name}}</span>
          <span class="mlr-5">=</span> 
        </div>
        <span class="color-c19357 font-arial font-bold font-16 lh-24">{{customerprogrammeInfo.totalNum || 0}}</span>
        <span class="lh-24">件</span>
        <span class="lh-24 ml-30">合计：</span><span class="color-c19357 font-arial font-bold font-20">￥{{customerprogrammeInfo.totalPrice ? Utils.toFixedNum(customerprogrammeInfo.totalPrice) : 0}}</span>
      </div>
      <div class="flex align-center justify-center room-list mb-90">
        <div class="btn-40 font-16 radius-round plr-36 mr-10" :class="roomIndex === index ? 'bg-c19357 color-ff' : 'border-292a2e'" v-for="(item, index) in customerprogrammeInfo.customerSpaceList" :key="index">
          {{item.name}}
        </div>
        <div class="btn-40 w-40 radius-round bg-292a2e color-ff font-18 font-bold" @click="addRoom"><i class="el-icon-plus"></i></div>
      </div>
      <div v-if="customerprogrammeInfo.customerSpaceList.length>0">
        <div class="room-section mb-90" v-for="(item, index) in customerprogrammeInfo.customerSpaceList" :key="index">
          <div class="flex align-center mb-40">
            <img :src="Utils.IMG_PREV+item.icon" class="mr-10" style="width:47px;height:40px">
            <div class="font-40 color-292a2e font-yahei">{{item.name}}</div>
            <div class="line"></div>
            <div>
              <div class="font-16 color-292a2e"><span class="color-ff5555">{{item.spaceNum || 0}}</span>件商品共</div>
              <div class="color-ff5555 font-16">¥{{Utils.toFixedNum(item.spacePrice)}}</div>
            </div>
            <div class="flex-1"></div>
            <div class="btn-40 bg-292a2e color-ff font-16 w-122 radius-round" @click="chooseGoods(item)">挑选更多</div>
            <div class="line"></div>
            <div class="btn-40 border-ff5555 font-16 w-122 radius-round" @click="toDeleteRoom(index)">删除空间</div>
            <div class="btn-40 border-292a2e radius-circle w-40 ml-10 cursor">
              <i class="el-icon-arrow-up font-bold font-20"></i>
            </div>
          </div>
          <div class="mb-70">
            <div v-if="item.customerSpaceGoodsList.length > 0">
              <div class="goods-item" v-for="(goodItem, goodIndex) in item.customerSpaceGoodsList" :key="goodIndex">
                <div class="mb-30 flex">
                  <div class="pic p-relative" v-if="goodItem.goodsPicList && goodItem.goodsPicList.length>0">
                    <el-image :src="Utils.IMG_PREV+goodItem.goodsPicList[0].pic" fit="cover" class="w-100 h-100"></el-image>
                    <img src="/images/wuhuoshangpin.png" alt="" class="wuhuo" v-if="goodItem.isEmpty == 1">
                  </div>
                  <div class="flex-1 w-0 ml-30">
                    <p class="font-12 color-ca mb-6">编码：{{goodItem.number}}</p>
                    <h3 class="font-16 color-292a2e font-yahei mb-6">{{goodItem.name}}</h3>
                    <h4 class="font-16 color-292a2e font-yahei mb-14">¥{{Utils.toFixedNum(goodItem.isPeferential==1 ? goodItem.summaryPreferentialPrice : goodItem.summaryPrice)}}</h4>
                    <div class="flex align-end">
                      <div>
                        <div class="font-12 color-94 mb-2" v-for="(attr,attrIndex) in goodItem.customerSpaceAttributeList" :key="attrIndex"><span class="mr-10">{{attr.standard}}</span>{{attr.value}}</div>
                      </div>
                      <div class="btn-30 radius-round ml-30 selectBtn" @click="toEditGoods(index,goodIndex)">选择商品规格</div>
                    </div>
                  </div>
                  <div class="flex-column align-end justify-space-between">
                    <img src="/images/shanchu.png" alt="" @click="deleteGoods(index,goodIndex)">
                    <el-input-number v-model="goodItem.quantity" @change="changeNumber" :min="1" class="number"></el-input-number>
                  </div>
                </div>
                <div class="hr-dashed mb-30"></div>
                <div class="flex align-end justify-end">
                  <span class="font-16 color-292a2e mb-6">小计：</span><span class="font-30 color-c19357 font-arial flex">¥{{Utils.toFixedNum((goodItem.isPeferential==1 ? goodItem.summaryPreferentialPrice : goodItem.summaryPrice) * goodItem.quantity)}}</span>
                </div>
              </div>
            </div>
            <div class="empty flex-column align-center justify-center" v-else>
              <img src="/images/kong.png" alt="" class="mb-18">
              <p class="font-16 color-94">暂无任何商品，请为此空间挑选商品</p>
            </div>
          </div>
          <div class="hr-dashed"></div>
        </div>
      </div>
    </div>
    <div class="settlement" :class="isFixed ? 'fixed' : ''">
      <div class="container flex align-center justify-space-between h-100">
        <div class="flex-1 flex align-center">
          <img src="/images/fangan-heji.png" alt="" class="mr-15">
          <div>
             <div class="flex justify-center align-center color-292a2e font-16 font-yahei">
              <div class="flex align-center" v-if="customerprogrammeInfo.customerSpaceList.length>0">
                <span v-for="(item, index) in customerprogrammeInfo.customerSpaceList" :key="index" class=" lh-24"><i class="el-icon-plus font-14 mlr-5" v-if="index !== 0"></i>{{item.name}}</span>
                <span class="mlr-5">=</span> 
              </div>
              <span class="font-arial color-292a2e font-bold font-16 lh-24">{{customerprogrammeInfo.totalNum || 0}}</span>
              <span class="lh-24">件</span>
            </div>
            <div class="flex align-center color-292a2e font-16 font-yahei">合计：<span class="font-22 font-arial">{{Utils.toFixedNum(customerprogrammeInfo.totalPrice)}}</span>元</div>
          </div>
        </div>
        <div class="font-16 color-292a2e mr-30 font-yahei">保存方案后，我们将会及时联系您，并为您的方案提供更完善可行的调整涉及！</div>
        <div class="btn-40 bg-292a2e color-ff w-122 radius-round font-yahei" @click="toSave">保存方案</div>
      </div>
    </div>
    <div class="modal1" v-if="isAdd" @scroll.stop.prevent @touchmove.prevent>
      <div class="content">
        <div class="flex align-center justify-space-between p-10">
          <div class="font-16 color-292a2e font-yahei">修改方案名</div>
          <img src="/images/guanbi.png" alt="" @click="onCloseName" class="cursor">
        </div>
        <el-input v-model="customerprogrammeInfo.name" type="textarea" resize="none" maxlength="15" class="font-32 text-center mtb-38" placeholder="点击输入方案名称(15字内)"></el-input>
        <div class="hr mb-20"></div>
        <div class="flex justify-center mb-20">
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round w-153 font-yahei" @click="submitName">确定</div>
        </div>
      </div>
    </div>
    <div class="modal" v-if="isAddRoom" @scroll.stop.prevent @touchmove.prevent>
      <div class="content" style="height: auto">
        <div class="flex align-center justify-space-between p-10">
          <div class="font-16 color-292a2e font-yahei">新增空间</div>
          <img src="/images/guanbi.png" alt="" @click="onCloseAdd" class="cursor">
        </div>
        <div class="hr mb-20"></div>
        <div class="flex-column flex-1 ptb-28" style="max-height:450px;overflow-y: scroll;">
          <div :class="spaceIndex == index ? 'bg-c19357 color-ff':'border-292a2e'" class="btn-40 font-16 radius-round plr-36 mb-10 text-center mlr-30" style="line-height:38px" v-for="(item, index) in spaceList" :key="index" @click="selectSpace(index)">{{item.name}}</div>
        </div>
        <div class="hr mb-20"></div>
        <div class="flex justify-center mb-20">
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round w-153 font-yahei" @click="submitAddRoom">确定</div>
        </div>
      </div>
    </div>
    <div class="modal" v-if="isEditGoods" @scroll.stop.prevent @touchmove.prevent>
      <div class="editGoods">
        <div class="flex align-center justify-space-between p-30">
          <div class="font-16 color-292a2e font-yahei">选择商品规格</div>
          <img src="/images/guanbi.png" alt="" @click="onCloseEditGoods" class="cursor">
        </div>
        <div class="hr"></div>
        <div class="p-30">
          <div class="flex align-center mb-30">
            <div class="pic p-relative" v-if="goodsObj.goodsPicList && goodsObj.goodsPicList.length>0">
              <el-image :src="Utils.IMG_PREV+goodsObj.goodsPicList[0].pic" fit="cover" class="w-100 h-100"></el-image>
              <img src="/images/wuhuoshangpin.png" alt="" class="wuhuo" v-if="goodsObj.isEmpty == 1">
            </div>
            <div class="ml-30">
              <p class="font-12 color-ca mb-6">编码：{{goodsObj.number || '-'}}</p>
              <p class="font-16 color-292a2e font-yahei mb-6">{{goodsObj.name}}</p>
              <p class="font-16 color-c19357 font-yahei">¥{{Utils.toFixedNum(goodsObj.isPeferential ? goodsObj.summaryPreferentialPrice : goodsObj.summaryPrice)}}</p>
            </div>
          </div>
            <div class="flex mb-5" v-for="(item,index) in goodsObj.goodsStandardList" :key="index">
              <span class="font-12 color-94 w-70 lh-30">{{item.name}}</span>
              <div class="flex-1 w-0 flex flex-wrap">
                <div v-for="(cellItem, cellIndex) in item.goodsAttributeList" :key="cellIndex" @click="selectAttribute(index,cellIndex,cellItem)" class="btn-30 plr-15 radius-round font-12 mr-5 mb-5" :class="cellItem.status == -1 ? 'color-ff linethrough bg-e9' : cellItem.selected ? 'color-c19357 bg-f6efe6' : 'color-292a2e bg-eeeff3'">
                  {{cellItem.value}}
                </div>
              </div>
            </div>
            <div class="flex mb-10">
              <span class="font-12 color-94 w-70 lh-30">个性化</span>
              <div class="flex-1 w-0">
                <el-input v-model="goodsObj.personalizedExplain"></el-input>
              </div>
            </div>
            <div class="flex mb-10">
              <span class="font-12 color-94 w-70 lh-30">个性化费用</span>
              <div class="w-170 ">
                <el-input v-model="goodsObj.personalizedPrice"></el-input>
              </div>
            </div>
        </div>
        <div class="hr mb-20"></div>
        <div class="flex justify-center">
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round w-153 font-yahei mb-20" @click="submitAttribute">确定</div>
        </div>
      </div>
    </div>
    <div class="modal " v-if="isSaveSuccess" @scroll.stop.prevent @touchmove.prevent>
      <div class="content-save">
        <div class="flex justify-end p-10 mb-28">
          <img src="/images/guanbi.png" alt="" @click="onCloseSave" class="cursor">
        </div>
        <div class="flex-1 flex-column align-center justify-center">
          <img src="/images/chenggong.png" alt="" class="mb-16">
          <div class="font-22 color-292a2e font-yahei mb-4">保存成功</div>
          <div class="font-14 color-94 font-yahei">此方案已保存到我的方案中</div>
          <div class="font-14 color-94 font-yahei">请保持手机畅通，我们会及时联系您</div>
          <div class="font-14 color-94 font-yahei mb-60">并为您的方案提供更完善可行的调整设计！</div>
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round plr-30 font-yahei" @click="lookMyCase">查看我的方案</div>
        </div>
      </div>
    </div>
    <div class="modal " v-if="isDelete" @scroll.stop.prevent @touchmove.prevent>
      <div class="delete">
        <div class="flex justify-end p-10 mb-28">
          <img src="/images/guanbi.png" alt="" @click="onCloseDelete" class="cursor">
        </div>
        <div class="flex-1 flex-column align-center justify-center">
          <img src="/images/tishi.png" alt="" class="mb-16">
          <div class="font-22 color-292a2e font-yahei mb-4">删除空间</div>
          <div class="font-14 color-ff5555 font-yahei mb-30">删除空间后，此空间的所有商品也将被删除</div>
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round w-153 font-yahei mb-10" @click="submitDelete">确定删除</div>
          <div class="btn-40 border-ca font-16 color-94 radius-round w-153 font-yahei" @click="onCloseDelete">取消</div>
        </div>
      </div>
    </div>
    <goods-list v-if="goodsShow" @on-colse="onColse" @on-add="onAdd" :currentSpace="currentSpace"></goods-list>
  </div>
</template>


<script>
import GoodsList from '@/components/GoodsList'

export default {
  name: 'MySchemeDetail',
  components: {GoodsList},
  computed: {},
  data () {
    return {
      value: '',
      vrList: [{
        url:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602583861525&di=45c2f77b0d0520ff2c9b7620967d9c0b&imgtype=0&src=http%3A%2F%2Ftgi12.jia.com%2F121%2F266%2F21266396.jpg'
      }, {
        url:'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602583959068&di=a784de98b4184106ef1e698002f4297b&imgtype=0&src=http%3A%2F%2F04.imgmini.eastday.com%2Fmobile%2F20180613%2F20180613133542_9138a5b1fab6038d0990453dc7e206b7_12.jpeg'
      }],
      room: [{
        name: '客厅'
      }, {
        name: '主卧'
      }, {
        name: '次卧'
      }, {
        name: '书房'
      }],
      num: 0,
      roomIndex: 0,
      goodList: [1,2,3],
      isAdd: false,
      isAddRoom: false,
      spaceList: [],
      spaceIndex: -1,
      roomName: '',
      isSaveSuccess: false,
      isEditGoods: false,
      isDelete: false,
      isFixed: true,
      windowHeight: null,
      pageHeight: null,
      id: '',
      customerprogrammeInfo: {
        customerSpaceList: []
      },
      goodsShow: false,
      currentSpace: {},
      currentSpaceIndex: '',
      goodsObj: {},
      changeSpaceIndex: '',
      changeSpaceDoodIndex: ''
    }
  },
  mounted () {
    window.addEventListener("scroll",this.onScroll3)
    this.windowHeight = document.documentElement.clientHeight
    this.id = this.$route.query.id.slice(0,-5)
    if (this.id) {
      this.getById()
    }
    this.getSpace()
  },
  beforeDestroy(){
    window.removeEventListener("scroll",this.onScroll3)
  },
  methods: {
    getById () {
      this.customerprogrammeInfo = {}
      this.axios.post(`customerProgramme/getById`, this.qs.stringify({id: this.id})).then(res => {
        if (res.data.success) {
          let info = res.data.data
          let list = []
          let num = 0
          let price = 0
          if (info.customerSpaceList.length > 0) {
              for (let i=0;i<info.customerSpaceList.length;i++) {
                list.push(info.customerSpaceList[i].name)
                let spacePrice = 0
                let spaceNum = 0
                for (let j=0;j<info.customerSpaceList[i].customerSpaceGoodsList.length;j++) {
                    spaceNum = spaceNum + info.customerSpaceList[i].customerSpaceGoodsList[j].quantity
                    spacePrice =spacePrice + info.customerSpaceList[i].customerSpaceGoodsList[j].quantity * (info.customerSpaceList[i].customerSpaceGoodsList[j].isPeferential ? info.customerSpaceList[i].customerSpaceGoodsList[j].summaryPreferentialPrice : info.customerSpaceList[i].customerSpaceGoodsList[j].summaryPrice)
                }
                info.customerSpaceList[i].spaceNum = spaceNum
                info.customerSpaceList[i].spacePrice= spacePrice
                num = num + info.customerSpaceList[i].spaceNum
                price = price + info.customerSpaceList[i].spacePrice
              }
          }
          info.newName = list
          info.totalNum = num
          info.totalPrice = price
          this.customerprogrammeInfo = info
          this.pageHeight = this.$refs.page.offsetHeight
          if (this.windowHeight > this.pageHeight) {
            this.isFixed = false
          }
        }
      })
    },
    getSpace () {
      this.axios.post('space/list', {}).then(res => {
        if (res.data.success) {
          this.spaceList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    selectSpace (index) {
      this.spaceIndex = index
    },
    onEdit () {
      this.isAdd = true
    },
    submitName () {
      if (!this.customerprogrammeInfo.name) {
        this.$message({
            type: 'warning',
            message: '请输入方案名称!'
          })
      } else {
        this.isAdd = false
      }
    },
    onCloseName () {
      this.isAdd = false
    },
    addRoom () {
      this.isAddRoom = true
    },
    onCloseAdd () {
      this.isAddRoom = false
      this.spaceIndex = -1
    },
    submitAddRoom () {
      if (this.spaceIndex != -1) {
        for (let i=0;i<this.customerprogrammeInfo.customerSpaceList.length;i++) {
          if (this.spaceList[this.spaceIndex].name == this.customerprogrammeInfo.customerSpaceList[i].name) {
            this.$message({
                message: `${this.spaceList[this.spaceIndex].name}已存在`,
                type: "warn",
                offset: 400
              });
              return
          }
        }
        let room = this.spaceList[this.spaceIndex]
        room.customerSpaceGoodsList = []
        this.customerprogrammeInfo.customerSpaceList.push(room)
      }
      this.onCloseAdd()
    },
    // 挑选更多
    chooseGoods (item) {
      this.goodsShow = true
      this.currentSpace = item
    },
    onAdd () {
      let info = this.customerprogrammeInfo
      let num = 0
      let price = 0
      for (let i=0;i<info.customerSpaceList.length;i++) {
        let spacePrice = 0
        let spaceNum = 0
        for (let j=0;j<info.customerSpaceList[i].customerSpaceGoodsList.length;j++) {
            spaceNum = spaceNum + info.customerSpaceList[i].customerSpaceGoodsList[j].quantity
            spacePrice =spacePrice + info.customerSpaceList[i].customerSpaceGoodsList[j].quantity * (info.customerSpaceList[i].customerSpaceGoodsList[j].isPeferential ? info.customerSpaceList[i].customerSpaceGoodsList[j].summaryPreferentialPrice : info.customerSpaceList[i].customerSpaceGoodsList[j].summaryPrice)
            info.customerSpaceList[i].customerSpaceGoodsList[j].customerSpaceAttributeList = info.customerSpaceList[i].customerSpaceGoodsList[j].customerSpaceAttributeList || info.customerSpaceList[i].customerSpaceGoodsList[j].newAttributeList
        }
        info.customerSpaceList[i].spaceNum = spaceNum
        info.customerSpaceList[i].spacePrice= spacePrice
        num = num + info.customerSpaceList[i].spaceNum
        price = price + info.customerSpaceList[i].spacePrice
      }
      info.totalNum = num
      info.totalPrice = price
      this.customerprogrammeInfo = info
    },
    // 数量加减
    changeNumber(e) {
      // console.log(e)
      this.onAdd()
    },
    onColse () {
      this.goodsShow = false
    },
    toSave () {
      console.log(this.customerprogrammeInfo)
      this.axios.post(`customerProgramme/modify`, this.customerprogrammeInfo).then(res => {
        if (res.data.success) {
          this.isSaveSuccess = true
        } else {
          this.$message({
            message: res.data.msg,
            type: "warn",
            offset: 400
          });
        }
      })
    },
    lookMyCase () {
      this.getById()
      this.isSaveSuccess = false
    },
    onCloseSave () {
      this.isSaveSuccess = false
    },
    toEditGoods (index,goodIndex) {
      this.isEditGoods = true
      this.changeSpaceIndex = index
      this.changeSpaceDoodIndex = goodIndex
      let goodAttr = this.customerprogrammeInfo.customerSpaceList[index].customerSpaceGoodsList[goodIndex].customerSpaceAttributeList
      let id = this.customerprogrammeInfo.customerSpaceList[index].customerSpaceGoodsList[goodIndex].goodsId
      // console.log(this.customerprogrammeInfo)
      // console.log(this.customerprogrammeInfo.customerSpaceList[index].customerSpaceGoodsList[goodIndex])
      this.axios.post(`goods/getById`, this.qs.stringify({id: id})).then(res => {
        if (res.data.success) {
          // console.log(res.data.data)
          // res.data.data.price = res.data.data.isPeferential ? res.data.data.preferentialPrice : res.data.data.price
          let list = res.data.data
          list.summaryPreferentialPrice =  this.customerprogrammeInfo.customerSpaceList[index].customerSpaceGoodsList[goodIndex].summaryPreferentialPrice
          list.summaryPrice = this.customerprogrammeInfo.customerSpaceList[index].customerSpaceGoodsList[goodIndex].summaryPrice
          list.personalizedExplain = this.customerprogrammeInfo.customerSpaceList[index].customerSpaceGoodsList[goodIndex].personalizedExplain
          list.personalizedPrice = this.customerprogrammeInfo.customerSpaceList[index].customerSpaceGoodsList[goodIndex].personalizedPrice
          if (list.goodsStandardList){
            for (let i=0;i<list.goodsStandardList.length;i++) {
              for (let j=0;j<goodAttr.length;j++) {
                if (list.goodsStandardList[i].name == goodAttr[j].standard) {
                  for (let m=0;m<list.goodsStandardList[i].goodsAttributeList.length;m++) {
                    if (goodAttr[j].value == list.goodsStandardList[i].goodsAttributeList[m].value) {
                      list.goodsStandardList[i].goodsAttributeList[m].selected = true
                    }
                  }
                }
              }
            }
          }
          this.goodsObj = list
          console.log(this.goodsObj)
        }
      })
    },
     // 选择属性
    selectAttribute (standIndex, tagIndex, item) {
      if (item.status == -1) {
        return
      }
      let selectAttribute = []
      for (let i=0;i<this.goodsObj.goodsStandardList[standIndex].goodsAttributeList.length;i++) {
        this.goodsObj.goodsStandardList[standIndex].goodsAttributeList[i].selected = false
      }
      this.goodsObj.goodsStandardList[standIndex].goodsAttributeList[tagIndex].selected = !this.goodsObj.goodsStandardList[standIndex].goodsAttributeList[tagIndex].selected
      this.goodsObj.isShow = !this.goodsObj.isShow
      let currentPrice = 0
       for (let n=0;n<this.goodsObj.goodsStandardList.length;n++) {
        for (let m=0;m<this.goodsObj.goodsStandardList[n].goodsAttributeList.length;m++) {
        if (this.goodsObj.goodsStandardList[n].goodsAttributeList[m].selected) {
          currentPrice = currentPrice + this.goodsObj.goodsStandardList[n].goodsAttributeList[m].priceRevision
        }
      }
      }
      // for (let m=0;m<this.goodsObj.goodsStandardList[standIndex].goodsAttributeList.length;m++) {
      //   if (this.goodsObj.goodsStandardList[standIndex].goodsAttributeList[m].selected) {
      //     currentPrice = currentPrice + this.goodsObj.goodsStandardList[standIndex].goodsAttributeList[m].priceRevision
      //   }
      // }
      this.goodsObj.summaryPreferentialPrice =   this.goodsObj.preferentialPrice + currentPrice
      this.goodsObj.summaryPrice = this.goodsObj.price + currentPrice
      for (let p=0;p<this.goodsObj.goodsStandardList.length;p++) {
        for (let q=0;q<this.goodsObj.goodsStandardList[p].goodsAttributeList.length;q++) {
          if (this.goodsObj.goodsStandardList[p].goodsAttributeList[q].selected) {
            let item = this.goodsObj.goodsStandardList[p].goodsAttributeList[q]
            item.standard = this.goodsObj.goodsStandardList[p].name
            selectAttribute.push(item)
          }
        }
      }
      // console.log(selectAttribute)
      this.goodsObj.newAttributeList = selectAttribute
      // console.log(this.goodsObj)
    },
    submitAttribute () {
      this.isEditGoods = false
      this.customerprogrammeInfo.customerSpaceList[this.changeSpaceIndex].customerSpaceGoodsList[this.changeSpaceDoodIndex].customerSpaceAttributeList = this.goodsObj.newAttributeList
    },
    onCloseEditGoods () {
      this.isEditGoods = false
    },
    toDeleteRoom (index) {
      this.isDelete = true
      this.currentSpaceIndex = index
    },
    onCloseDelete () {
      this.isDelete = false
    },
    submitDelete () {
      this.customerprogrammeInfo.customerSpaceList.splice(this.currentSpaceIndex,1)
      this.isDelete = false
    },
    deleteGoods (index,goodIndex) {
      this.$confirm('确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.customerprogrammeInfo.customerSpaceList[index].customerSpaceGoodsList.splice(goodIndex, 1)
          this.onAdd()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    onScroll3 () {
      this.pageHeight = this.$refs.page.offsetHeight
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > (this.pageHeight - this.windowHeight)) {
        this.isFixed = false
      } else {
        this.isFixed = true
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.wuhuo{
  position: absolute;
  top: 0;
  left: 0;
}
  .page{
    padding: 30px 0 90px;
    background: #eeeff3;
  }
  .room-list{
    position: relative;
    &::after{
      content: '';
      display: block;
      width: 100%;
      height: 19px;
      position: absolute;
      top: 0;
      left: 0;
      border-bottom: 1px solid #e9e9e9;
    }
    .btn-40{
      z-index: 9;
    }
    .border-292a2e{
      background: #eeeff3;
    }
  }
  .room-section{
    .line{
      height: 40px;
      width: 1px;
      background: #cacaca;
      margin: 0 20px;
    }
    .btn-40.bg-292a2e:hover{
      background: #c19357;
    }
    .btn-40.border-ff5555:hover{
      background: #ff5555;
      border: 0;
      color: #fff;
    }
  }
  .goods-item{
    background: #fff;
    box-shadow: 0px 30px 70px 0px rgba(44, 51, 59, 0.07);
    padding: 30px;
    margin-bottom: 20px;
    border-radius: 4px;
    .pic{
      width: 192px;
      height: 126px;
      border-radius: 4px;
      overflow: hidden;
    }
    .selectBtn{
      color: #292a2e;
      font-size: 12px;
      width: 101px;
      background: #eeeff3;
      &:hover{
        background: #c19357;
        color: #fff;
      }
    }
  }
  .empty{
    height: 270px;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 30px 70px 0px rgba(44, 51, 59, 0.07);
  }

  .settlement{
    height: 120px;
    width: 100%;
    background: #c19357;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .fixed{
    position: fixed;
    z-index: 10;
  }
  .modal1{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
      width: 394px;
      background: #ffffff;
      border-radius: 4px;
    }
    .content-save{
      width: 394px;
      height: 432px;
      background: #ffffff;
      border-radius: 4px;
    }
  }
  .modal{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
      width: 394px;
      height: 253px;
      background: #ffffff;
      border-radius: 4px;
    }
    .content-save{
      width: 394px;
      height: 432px;
      background: #ffffff;
      border-radius: 4px;
    }
    .editGoods{
      width: 1105px;
      background: #ffffff;
      border-radius: 4px;
      .pic {
        width: 192px;
        height: 126px;
        border-radius: 4px;
        box-shadow: 0 30px 70px 0 rgba(44, 51, 59, 0.07);
        overflow: hidden;
      }
    }
    .delete {
      width: 394px;
      height: 405px;
      background: #ffffff;
      border-radius: 4px;
    }
  }

  .w-40{
    width: 40px;
  }
  .w-70{
    width: 70px;
  }
  .w-101{
    width: 101px;
  }
  .w-122{
    width: 122px;
  }
  .w-147{
    width: 147px;
  }
  .w-153{
    width: 153px;
  }
  .w-172{
    width: 172px;
  }
  .h-400{
    height: 400px;
  }
  .lh-24{
    line-height: 24px;
  }

  ::v-deep{
    .content .el-input__inner{
      text-align: center;
      border: 0;
      height: 50px;
      line-height: 50px;
    }
    .number {
      .el-input__inner{
        height: 30px;
        line-height: 30px;
        border-radius: 20px;
        border: solid 1px #292a2e;
        color: #292a2e;
        font-size: 12px;
      }
      .el-input-number .el-input__inner{
        padding: 0 30px;
      }
      &.el-input-number{
        width: 110px;
        line-height: 30px;
        border-radius: 20px;
        overflow: hidden;
        .el-input__inner{
          font-size: 16px;
          height: 30px;
          border: 0;
          color: #292a2e;
          border: solid 1px #292a2e!important;
          padding: 0 30px;
        }
      }
      .el-input-number__decrease, .el-input-number__increase{
        width: 30px;
        height: 30px;
        font-size: 12px;
        top: 0;
        border: 0;
        background: transparent;
        color: #292a2e;
        font-weight: bold;
      }
      .el-input-number__decrease{
        left: 0;
      }
      .el-input-number__increase{
        right: 0;
      }
    }
    .editGoods .el-input__inner{
      height: 30px;
      line-height: 30px;
      border-radius: 20px;
      border: solid 1px #e9e9e9;
      color: #292a2e;
      font-size: 12px;
    }
  }
  ::v-deep{
    .content .el-textarea__inner{
      text-align: center;
      border: 0;
      height: 130px;
      padding: 0 26px;
    }
  }
</style>
